module.exports = __webpack_public_path__ + "static/media/pop-up-2.68529739.png";